import { render, staticRenderFns } from "./AiSuggestionProductParser.vue?vue&type=template&id=7f7c0189"
import script from "./AiSuggestionProductParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionProductParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports